export const IMAGE_SIZES = {
  desktop: 150,
  lgTablet: 140,
  mdTablet: 130,
  mobile: 95,
} as const;

export const OBJECT_FIT_COVER = { objectFit: "cover" as const };

export const formatName = (name: string) => {
  return name ? name.charAt(0).toUpperCase() + name.slice(1) : "";
};
